import tx from "../tx";

const items = [
    //{id:0  , nameTx:'New Boooking'  , name:'New Booking'     }, estado interno
    {id:1  , nameTx:'Cancelled'  , name:'Cancelled'     },
    {id:10 , nameTx:'Pre-booked' , name:'Pre-booked'    },
    {id:20 , nameTx:'Booked'     , name:'Booked'        },
    // {id:30 , nameTx:'Check-in'   , name:'Cche-in'        }, reservada futuro
    {id:40 , nameTx:'Inside'     , name:'Inside'        },
    {id:50 , nameTx:'Check Out'  , name:'Check Out'     }, //proceso de checkout
    {id:60 , nameTx:'Finalized'  , name:'Finalized'     },
];

const values = Object.freeze ({
    // NEW  : 0 , Uso interno
    CANCELLED  : 1 ,
    PREBOOKED  : 10,
    BOOKED     : 20,
    //CHECK_IN: 30 Reservada futuro
    INSIDE     : 40,
    CHECK_OUT  : 50,
    FINALIZED  : 60
});

function getName(status) {
    switch(status) {
        case values.CANCELLED  : return  items[0].name;
        case values.PREBOOKED  : return  items[1].name;
        case values.BOOKED     : return  items[2].name;
        case values.INSIDE     : return  items[3].name;
        case values.CHECK_OUT  : return  items[4].name;
        case values.FINALIZED  : return  items[5].name;
        default:return status;
    }
}

function translateNames() {
    for (let item of items) {
        item.name = tx.t(item.nameTx);
    }
}

function getItems() { return items }



export default {
    getItems, getName, translateNames, values
}

